import React from 'react';

function Namibia(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124042)">
        <mask
          id="mask0_800_124042"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124042)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#009933"
          />
          <mask
            id="mask1_800_124042"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124042)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24L36 0H0Z"
              fill="#3195F9"
            />
            <path
              d="M-1.00355 27.1379L-0.482094 27.9777L0.363663 27.4659L39.5495 3.75659L40.3533 3.27025L39.918 2.43769L37.2834 -2.60149L36.7949 -3.5359L35.8877 -2.99859L-3.88751 20.5579L-4.76617 21.0783L-4.22748 21.9458L-1.00355 27.1379Z"
              fill="#E31D1C"
              stroke="#F7FCFF"
              strokeWidth="2"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.00853 9.24476L5.55267 10.8593L5.20002 8.81402L3.03105 9.56518L3.8761 7.6372L1.5752 7.32374L3.39151 6.02964L1.5752 4.73555L3.8761 4.42208L3.03105 2.49411L5.20002 3.24526L5.55267 1.20001L7.00853 2.81452L8.46439 1.20001L8.81704 3.24526L10.986 2.49411L10.141 4.42208L12.4419 4.73555L10.6255 6.02964L12.4419 7.32374L10.141 7.6372L10.986 9.56518L8.81704 8.81402L8.46439 10.8593L7.00853 9.24476ZM7.00853 8.52964C8.56183 8.52964 9.82103 7.41035 9.82103 6.02964C9.82103 4.64893 8.56183 3.52964 7.00853 3.52964C5.45523 3.52964 4.19603 4.64893 4.19603 6.02964C4.19603 7.41035 5.45523 8.52964 7.00853 8.52964ZM9.25844 6.02965C9.25844 7.13422 8.25108 8.02965 7.00844 8.02965C5.7658 8.02965 4.75844 7.13422 4.75844 6.02965C4.75844 4.92508 5.7658 4.02965 7.00844 4.02965C8.25108 4.02965 9.25844 4.92508 9.25844 6.02965Z"
              fill="#FECA00"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124042">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Namibia;
